






































import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import ClipboardJS from 'clipboard'
import { sa } from '@/utils/sa'

@Component
export default class Share extends Vue {
  @Prop() link!: string | number
  @Prop() value!: boolean | number | string
  public copyBtn: any = null
  public copied = false
  @Emit()
  public shareToWx() {}
  @Watch('value')
  onValueChange(val) {
    if (val) {
      this.copyBtn = new ClipboardJS(this.$refs.copy)
    } else {
      this.copyBtn.destroy()
      this.copied = false
    }
  }
  public mounted() {
    let copy = ClipboardJS.isSupported()
    this.copyBtn = new ClipboardJS(this.$refs.copy)
  }
  public copyLink() {
    let that = this
    let clipboard = this.copyBtn
    clipboard.on('success', function(e) {
      console.log(e)
      // 释放内存
      that.copied = true
      that.copyBtn.destroy()
      // 埋点
      setTimeout(() => {
        sa.track('ContentRepository_Share', {
          action: '开始分享',
          shareChannel: '复制分享'
        })
      }, 50)
    })
    clipboard.on('error', function(e) {
      console.log(e)
    })
  }
  public shareToQQ() {
    let baseUrl = 'https://connect.qq.com/widget/shareqq/index.html?'
    let params = {
      url: this.link + '&style="qq"' || location.origin + '/search',
      title: '邀请注册',
      summary: '每邀请1位老师完成注册您将获得1张周卡(¥25)，更有邀请累计奖励。',
      pics: './../../assets/images/red_bag.png',
      width: 32,
      height: 32,
      desc: '注册免费下载教学资料，真题、名校题应有尽有',
      site: '一起内容库'
    }
    var str: any = []
    setTimeout(() => {
      sa.track('ContentRepository_Share', {
        action: '开始分享',
        shareChannel: 'QQ分享'
      })
    }, 50)
    for (var i in params) {
      str.push(`${i}=${encodeURIComponent(params[i] || '')}`)
    }

    let url = baseUrl + str.join('&')
    window.open(url)
  }
}
